import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  width: 95%;
  min-height: 40px;
  max-height: 10rem;
  background: #fff;
  bottom: 100%;
  left: -25%;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px,
    rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
  transform: translateX(27%) translateY(0.7rem);
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  color: #eff1f5;

  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  cursor: pointer;
  visibility: ${({ open }) => (!open ? "hidden" : "visible")};
  border: 2px solid #999;
  border-radius: 10px;
  z-index: 2;

  &:after {
    content: "";

    display: block;
    position: absolute;
    bottom: -15px;
    left: calc(50% - 14px);

    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-top: 20px solid #fff;
  }

  span:nth-child(1) {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  span:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border: none;
  }
`;
export const CellContainer = styled.div`
  overflow: auto;
  width: 95%;
  min-height: 30px;
  max-height: 7.5rem;

  /* Designing for scroll-bar */
  ::-webkit-scrollbar {
    width: 6px;
    margin-left: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: gainsboro;
    border-radius: 5px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: black;
    border-radius: 5px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  min-height: 2.5rem;
  width: 98%;

  span {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
    margin-left: 0.7rem;

    font-family: "Sora";
    font-style: normal;
    font-weight: 600;
    font-size: 0.8rem;
    line-height: 1rem;
    color: #232323;

    overflow-x: hidden;
  }

  border-bottom: 0.07rem solid #ccc;
`;

export const PlaceHolder = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
`;
